export default "https://dakcheck.solease.nl/static/media/xIcon.34ce102a.svg";